type Trim<S extends string> = S extends ` ${infer R}` ? Trim<R> : S extends `${infer R} ` ? Trim<R> : S;

type Slugify<T extends string> = T extends `${infer Head} ${infer Tail}` ? `${Lowercase<Head>}-${Slugify<Tail>}` : Lowercase<T>;

export const prepareSlug = <T extends string>(input?: T): Slugify<Trim<T>> => {
  return (input ?? '').trim().toLowerCase().replace(/\s+/g, '-') as Slugify<Trim<T>>;
};
